// Identidad anónima estilo Nostr: al primer ingreso se genera un par de claves
// secp256k1; la privada queda SOLO en el dispositivo (localStorage) y la pública
// (pubkey) sirve de ID anónimo para la analítica. Mismo enfoque que el juego de GO
// del taller de IA (nostr-tools), pero sin publicar a relays.
import { generateSecretKey, getPublicKey } from 'nostr-tools/pure';

const KEY = 'm26:identity';

export interface Identity {
  sk: string; // clave privada (hex) — nunca sale del dispositivo
  pub: string; // clave pública (hex) — ID anónimo
  created: number;
}

function toHex(bytes: Uint8Array): string {
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

// ¿Es la primera vez? (consultar ANTES de getIdentity, que la crea si falta)
export function isFirstVisit(): boolean {
  try {
    return localStorage.getItem(KEY) === null;
  } catch {
    return false;
  }
}

export function getIdentity(): Identity {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw) as Identity;
  } catch {
    /* localStorage no disponible */
  }
  const sk = generateSecretKey();
  const id: Identity = { sk: toHex(sk), pub: getPublicKey(sk), created: Date.now() };
  try {
    localStorage.setItem(KEY, JSON.stringify(id));
  } catch {
    /* ignorar */
  }
  return id;
}
